import { motion } from 'framer-motion';
import styles from './SuccessOverlay.module.scss';

export default function SuccessOverlay({ isVisible }) {
  if (!isVisible) return null;

  return (
    <motion.div 
      className={styles.overlay}
      initial={{ opacity: 0, backdropFilter: 'blur(0px)' }}
      animate={{ opacity: 1, backdropFilter: 'blur(8px)' }}
      exit={{ opacity: 0, backdropFilter: 'blur(0px)' }}
    >
      <motion.div 
        className={styles.card}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', damping: 15 }}
      >
        <svg 
          viewBox="0 0 52 52" 
          className={styles.checkmark}
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            fill="none"
            strokeWidth="5"
            stroke="currentColor"
            d="M14 27l7.5 7.5L38 18"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
          />
        </svg>
      </motion.div>
    </motion.div>
  );
}